const PUNCTUATION_SYMBOLS_REGEX = /([.,/#!$%^&*;:{}=\-_`~ ()—\][])+$/g;
const HTML_TAGS_DEFAULT_REGEX = /<\/?[^>]+>/g;

export const againstAtLeast = (input: string, size = 1) => input.length >= size;

export const notEmpty = (input?: string | null) =>
  input !== null && input !== undefined && againstAtLeast(input);

export const removeHtmlTags = (
  input: string,
  regex = HTML_TAGS_DEFAULT_REGEX
): string => {
  return notEmpty(input) ? input.replace(regex, '') : '';
};

export const truncateText = (text: string, needLength: number) => {
  return text.slice(0, needLength).trim();
};

export const cropText = (text: string, needLength: number, endSeparator = '...') => {
  const textWithoutTags = removeHtmlTags(text);

  if (textWithoutTags.length <= needLength) {
    return text;
  }

  const words = textWithoutTags.split(' ');
  let result = '';

  for (let i = 0; i < words.length; i++) {
    const word = words[i];
    if (word.length + result.length <= needLength - endSeparator.length) {
      result += `${word} `;
    } else if (PUNCTUATION_SYMBOLS_REGEX.exec(result[result.length - 1])) {
      result = result.substring(0, result.length - 1);
    } else {
      break;
    }
  }

  return `${result}${endSeparator}`;
};

export const formatString = (text: string, needLength: number, hasBreakWord = false) => {
  if (needLength <= 0) {
    return '';
  }

  const etc = '...';

  if (hasBreakWord) {
    const textWithoutTags = removeHtmlTags(text);
    return textWithoutTags.length <= needLength
      ? textWithoutTags
      : `${truncateText(textWithoutTags, needLength)}${etc}`;
  }

  return cropText(text, needLength, etc);
};

export const capitalize = (s: string) => {
  return s.charAt(0).toUpperCase() + s.slice(1);
};
